<template>
  <div class="toastification">
    <div class="d-flex align-items-start">
      <b-avatar
        variant="success"
        size="1.8rem"
        class="mr-75 flex-shrink-0"
      >
        <app-feather
          :icon="appConstants.app.featherIcon.types.ALERT_TRIANGLE_ICON"
          size="15"
        />
      </b-avatar>
      <div class="d-flex flex-grow-1">
        <div class="w-100">
          <h5 class="mb-0 font-weight-bolder toastification-title text-success">Внимание!</h5>
          <h5 class="mt-1 mb-1 text-body font-weight-bold">{{ title }}</h5>
          <hr>
          <div
            v-if="patientFullName"
            class="d-flex align-items-center"
          >
            <span class="text-body mr-50 font-weight-bold">ФИО:</span>
            <small class="d-inline-block text-body">{{ patientFullName }}</small>
          </div>
          <div
            v-if="formattedPhone"
            class="d-flex align-items-center"
          >
            <span class="text-body mr-50 font-weight-bold">Телефон:</span>
            <small class="d-inline-block text-body">{{ formattedPhone }}</small>
          </div>
          <div
            v-if="appointmentDate"
            class="d-flex align-items-center"
          >
            <span class="text-body mr-50 font-weight-bold">Дата приема:</span>
            <small class="d-inline-block text-body">{{ appointmentDate }}</small>
          </div>
          <div
            class="mt-1"
            @click="$emit('click-toast')"
          >
            <b-link :to="routerLinkParamsForShowPatientHistoryRequest">
              <small class="d-inline-block">Подробнее</small>
            </b-link>
          </div>
        </div>
        <span class="toastification-close-icon ml-auto">
          <app-feather
            :icon="appConstants.app.featherIcon.types.X_ICON"
            class="text-body ml-1 cursor-pointer"
            @click="$emit('close-toast')"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar, BBadge, BLink } from 'bootstrap-vue'
import { computed } from 'vue'
import { mixins } from '@/mixins'
import AppFeather from '@/views/components/app-feather/AppFeather.vue'
import appConstants from '@/constants/constants'

export default {
  name: 'ToastificationPatientCameInToAppointmentNotification',
  components: { AppFeather, BBadge, BAvatar, BLink },
  props: {
    appointmentId: Number,
    title: String,
    patientId: Number,
    patientFullName: String,
    phoneCode: String,
    phone: String,
    appointmentDate: String,
  },
  setup(props) {
    const formattedPhone = computed(() => {
      if (props.phoneCode && props.phone) {
        const number = props.phone
        let result = props.phone
        if (number.length === 10) {
          result = '(' + number.substring(0, 3) + ') ' + number.substring(3, 6) + '-' + number.substring(6, 8)
            + '-' + number.substring(8, 10)
        } else if (number.length === 9) {
          result = '(' + number.substring(0, 2) + ') ' + number.substring(2, 5) + '-' + number.substring(5, 7)
            + '-' + number.substring(7, 9)
        }
        return '+' + props.phoneCode + ' ' + result
      }
      return null
    })
    const routerLinkParamsForShowPatientHistoryRequest = computed(() => {
      let activeTab = mixins.methods.userHasProfmanDentalProgramVersion() ? 2 : 3
      activeTab = mixins.methods.tabDentistryIsHidden() ? activeTab - 1 : activeTab
      return {
        path: `/apps/patient_cards/patient-edit/${props.patientId}`,
        params: {
          patientId: props.patientId,
          activeTabToShow: activeTab,
          routerBreadcrumbParams: { sourceItemLabel: props.patientFullName },
        },
        query: {
          sourceItemLabel: props.patientFullName,
          activeTabToShow: activeTab,
        }
      }
    })

    return {
      formattedPhone,
      routerLinkParamsForShowPatientHistoryRequest,

      appConstants,
    }
  }
}
</script>
